import moment, { MomentInput } from "moment-timezone";

/**
 * Check if can join the session: between start -15 mins ~ end + 30 mins
 * @param start ms from epoch
 * @param end ms from epoch
 */

export default function canJoinSessionForPro(
  start: MomentInput,
  end: MomentInput,
) {
  const now = moment();
  const rangeStart = moment(start).diff(now, "minutes", true);
  const rangeEnd = moment(end).diff(now, "minutes", true);
  return rangeStart <= 15 && rangeEnd >= -30;
}
